import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '@edusense/shared-ui-kit';
import * as S from './CurriculumTabContent.styles';
/**
 * 커리큘럼 임포트 확인 다이얼로그 컴포넌트
 * 
 * 마크다운 파일에서 파싱된 커리큘럼을 임포트하기 전
 * 사용자 확인을 받는 다이얼로그
 */ export const ImportConfirmationDialog = ({ isFullWidth, parsedSectionsForImport, onConfirm, onCancel })=>{
    return /*#__PURE__*/ _jsx(S.Container, {
        $isFullWidth: isFullWidth,
        children: /*#__PURE__*/ _jsxs("div", {
            style: {
                padding: '20px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                backgroundColor: 'white',
                margin: '20px'
            },
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    children: "커리큘럼 임포트 확인"
                }),
                /*#__PURE__*/ _jsxs("p", {
                    children: [
                        parsedSectionsForImport.length,
                        "개의 섹션을 찾았습니다. 현재 커리큘럼을 덮어쓰시겠습니까?"
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    style: {
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "outline",
                            onClick: onCancel,
                            children: "취소"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "primary",
                            onClick: onConfirm,
                            children: "임포트"
                        })
                    ]
                })
            ]
        })
    });
};
